import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../../core';
import { Observable } from 'rxjs';
import { SponsorStudySitesReadModel } from './sponsor-study-sites-read-model';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { SponsorStudySite } from './sponsor-study-site';

@Injectable()
export class SponsorStudySitesStorage {
    constructor(
        private settings: Settings,
        private http: HttpClient
    ) {
    }
    
    public loadSponsorStudySites(studyId: number): Observable<SponsorStudySite[]> {
        return this.http.get(`${this.settings.apiUrl}/sponsor/study/${studyId}/sites`).pipe(
            map((response) => deserialize(response, SponsorStudySitesReadModel).sites),
        );
    }
}